export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-25.c720be5f.png";